import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseService } from '../../shared-service/base.service';
import { DataService } from '../../shared-service/data.service';

declare var jquery: any;
declare var $: any;

@Injectable()
export class NavbarService {

	ResourceKey: Object = {};

	subjectToBeObserved!: BehaviorSubject<Object>;
	currentValue: any;

	setObservableValue(val: Object) {
		this.subjectToBeObserved = new BehaviorSubject<object>(val);
		this.currentValue = this.subjectToBeObserved.asObservable();
	}

	changeValue(message: object) {
		this.subjectToBeObserved.next(message)
	}



	subjectToBeObservedGlobalSearch!: BehaviorSubject<Object>;
	currentValueGlobalSearch: any;

	setObservableGlobalSearchValue(val: Object) {
		this.subjectToBeObservedGlobalSearch = new BehaviorSubject<object>(val);
		this.currentValueGlobalSearch = this.subjectToBeObservedGlobalSearch.asObservable();
	}

	changeGlobalSearchValue(message: object) {
		this.subjectToBeObservedGlobalSearch.next(message)
	}

	constructor(private bs: BaseService, private dataService: DataService) {
		this.bs.log('info', "Loaded NavbarService");
	}

	updateStoreData(key: PropertyKey, data: Object) {
		return this.dataService.setStoreData(key, data);
	}

	getStoreData(key: PropertyKey) {
		return this.dataService.getDataStoreData(key);
	}

	getQuickLinksFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'Home/GetMenuDetails';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getUserDetails(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'UserProfile/GetUserDetails';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getHomePageOptionFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'Home/GetHomePageOption';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};
	getPublicAnnouncementFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/GetPublicAnnouncements';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	setPublicAnnouncementReadFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/ReadPublicAnnouncements';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	updateLastUserAlertCheck(body: Object, key: PropertyKey|null) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/UpdateLastAlertCheck';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getNotificationCountFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/GetTotalNotificationCount';
			this.dataService.doPostWithPromise(key, controllerMethod, body, true, false).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('info', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getActiveWallStatusFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/GetActiveWallStatus';
			this.dataService.doPostWithPromise(key, controllerMethod, body, true, false).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('info', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};
	
	setActiveWallStatusFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/SetActiveWallStatus';
			this.dataService.doPostWithPromise(key, controllerMethod, body, true, false).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('info', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getPublicAnnouncementCountFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/GetPublicAnnouncementCount';
			this.dataService.doPostWithPromise(key, controllerMethod, body, true, false).then((data) => {
				this.bs.log('error', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getNotificatiionListFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/GetNotificationList';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	setNotificationStatusToServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'SystemAlert/SetNotificationStatus';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};
	getGlobalSearchDataFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'GlobalSearch/Search';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getGlobalSearchAutoCmplteDataFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'GlobalSearch/Suggestion';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};



	getSearchParams() {
		return {
			'CorporateId': this.bs.user['CorporateId'],
			'HostName': this.bs.config.hostName,
			'PageSize': this.bs.config["pageSize"],
			'PageNumber': 1,
			'Skip': 0,
			'SearchBy': this.bs.user['UserId'],
			'SearchText': "",
			'SearchScreenType': 4,
			'OSVisibilityClaim': this.bs.user['OSVisibilityClaim'],
			'RoleVisibilityClaim': this.bs.user['RoleVisibilityClaim'],
			'JobRoleVisibilityClaim': this.bs.user['JobRoleVisibilityClaim'],
			'RAVisibilityClaim': this.bs.user['RAVisibilityClaim'],
			'Skills': this.bs.user['UserSkills'],
			'EntityType': "",
			'SearchTypeList': [] as any[],
			'WithCertificateFilter': false,
			'SortBy': 'DFLT',
			'OnlyPublicFilter': false,
			'UserId': this.bs.user['UserId'],
			'SearchType': "",
		};
	}
	getAutoCmplteData(fn:any, autocmpltsrchtext:any, entityType:any, searchType:any) {
		let params = this.getSearchParams();
		params.SearchText = autocmpltsrchtext;
		params.EntityType = entityType;
		params.SearchType = searchType;
		// params.SearchTypeList = [searchType];
		params.SearchTypeList = [];

		this.getGlobalSearchAutoCmplteDataFromServer(params, this.bs.config.storageSearchApiKey).then((data) => {
			fn(data);
		}, (data) => {
			this.bs.log('error', 'Error in getting list');
			fn(null);
		});
	}

	getUserPrivilegeDetails(id: Object, key: PropertyKey){
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'UserProfile/GetUserPrivilegeDetails/'+id;
			this.dataService.doPostWithPromise(key, controllerMethod, {}).then((data) => { 
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};
	
}


